/* RoamEnergy November promo: auto-add the matching extended warranty when a
   PowerBridge is added from its product page. The Liquid templates render
   data-roam-promo-warranty-variant-id on a product-page ancestor of the
   add-to-cart button only for the 5 promo products and only inside the promo
   window, so this script never runs for other products or after Dec 1. */
(function () {
  'use strict';
  if (window.__roamPromoAutoAddInstalled) { return; }
  window.__roamPromoAutoAddInstalled = true;

  var MARKER = 'data-roam-promo-warranty-variant-id';
  var busy = false;

  function cartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function fetchJson(url, options, timeoutMs) {
    var controller = null;
    if (typeof AbortController !== 'undefined') {
      controller = new AbortController();
      setTimeout(function () { controller.abort(); }, timeoutMs || 15000);
    }
    var opts = options || {};
    if (controller) { opts.signal = controller.signal; }
    return fetch(url, opts).then(function (response) {
      if (!response.ok) { throw new Error('Request failed: ' + response.status); }
      return response.json();
    });
  }

  function readQty(input) {
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 1) { return 1; }
    return n;
  }

  function quantityFor(cartAddEl) {
    var sticky = null;
    if (cartAddEl.closest) { sticky = cartAddEl.closest('.xo-sticky-cart'); }
    if (sticky) {
      var stickyInput = sticky.querySelector('xo-cart-quantity input');
      if (stickyInput) { return readQty(stickyInput); }
    }
    var productEl = cartAddEl.closest ? cartAddEl.closest('xo-product') : null;
    var root = productEl || document;
    var inputs = root.querySelectorAll('xo-cart-quantity input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].closest && inputs[i].closest('.xo-sticky-cart')) { continue; }
      return readQty(inputs[i]);
    }
    return 1;
  }

  function variantIdFor(cartAddEl) {
    var v = cartAddEl.getAttribute('xo-variant-id');
    if (v && /^[0-9]+$/.test(v)) { return v; }
    var productEl = cartAddEl.closest ? cartAddEl.closest('xo-product') : null;
    var root = productEl || document;
    var idInput = root.querySelector('form input[name="id"]');
    if (idInput && idInput.value && /^[0-9]+$/.test(idInput.value)) { return idInput.value; }
    return null;
  }

  function fallback(buttonEl) {
    window.__roamPromoAutoAddFallback = true;
    buttonEl.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  }

  document.addEventListener('click', function (event) {
    if (window.__roamPromoAutoAddFallback) {
      window.__roamPromoAutoAddFallback = false;
      return;
    }
    var target = event.target;
    if (!target || !target.closest) { return; }
    var cartAddEl = target.closest('xo-cart-add');
    if (!cartAddEl) { return; }
    if (cartAddEl.hasAttribute('xo-disabled')) { return; }
    var buttonEl = target.closest('button');
    if (!buttonEl) { return; }
    var markerEl = cartAddEl.closest('[' + MARKER + ']');
    if (!markerEl) { return; }
    var warrantyVariantId = markerEl.getAttribute(MARKER);
    if (!warrantyVariantId || !/^[0-9]+$/.test(warrantyVariantId)) { return; }
    var variantId = variantIdFor(cartAddEl);
    if (!variantId) { return; }
    var quantity = quantityFor(cartAddEl);

    event.preventDefault();
    event.stopPropagation();
    if (busy) { return; }
    busy = true;

    fetchJson('/cart.js', { credentials: 'same-origin' }).then(function (cart) {
      var pbQty = 0;
      var warrantyQty = 0;
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].variant_id) === String(variantId)) { pbQty += items[i].quantity; }
        if (String(items[i].variant_id) === String(warrantyVariantId)) { warrantyQty += items[i].quantity; }
      }
      var needed = pbQty + quantity - warrantyQty;
      var toAdd = [{ id: Number(variantId), quantity: quantity }];
      if (needed > 0) {
        toAdd.push({ id: Number(warrantyVariantId), quantity: needed });
      }
      return fetchJson('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: toAdd })
      });
    }).then(function () {
      busy = false;
      window.location.href = cartRoot() + 'cart';
    }).catch(function () {
      busy = false;
      fallback(buttonEl);
    });
  }, true);
})();
